module.exports = __webpack_public_path__ + "img/swipe.803a81b4.svg";